import React, { useRef } from "react";
import logo from "../images/icons/logo_white.webp";
import steep from "../images/steep.png";
import mailIcon from "../images/icons/envelope.svg";
import phoneIcon from "../images/icons/phone.svg";
import facebookIcon from "../images/icons/facebook.svg";
import instagramIcon from "../images/icons/instagram.svg";

const Subscribe = ({ showContact }) => {
  return (
    <div className="subscribe brush-top brush-bottom">
      <div className="image">
        <img src={steep} alt={"steeping tea"} />
      </div>
      <div className="content">
        <div className="container">
          <div className="icon">
            <img src={logo} alt={"rodo tea logo in white"} />
          </div>
          <div className="header">You’re welcome to join us!</div>
          <div className="sub-text">
            A family that sips together stays together.
            <br />
            Follow us on social media to stay updated on all our activities.
            <br />
            Call, email, or send us a DM for inquiries.
          </div>

          <div className="action-btn-container"></div>

          <div className="action-btn-container">
            {showContact && (
              <a href="mailto:contact@rodozee.com" className="action-btn">
                <img src={mailIcon} alt="mail" />
              </a>
            )}

            {showContact && (
              <a href="tel:+2347016275384" className="action-btn">
                <img src={phoneIcon} alt="phone" />
              </a>
            )}
            <a href="https://www.facebook.com/rodozee" target="_blank" rel="noopener noreferrer" className="action-btn">
              <img src={facebookIcon} alt="facebook" />
            </a>
            <a href="https://www.instagram.com/rodozee" target="_blank" rel="noopener noreferrer" className="action-btn">
              <img src={instagramIcon} alt="instagram" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
